import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TeacherDashboard  from './pages/TeacherDashboard';
import TeacherDashboardB from './pages/TeacherDashboardB';
import AdminDashboard    from './pages/AdminDashboard';
import AdminDashboardB   from './pages/AdminDashboardB';
import PublicSchedule    from './pages/PublicSchedule';
import Login             from './pages/Login';
import Navbar            from './components/Navbar';
import { WeekNavContext } from './contexts/WeekNavContext';
import { getCurrentWeek } from './utils/dateUtils';
import './styles/swiss.css';
import './index.css';

function App() {
  const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek);
  const [designVariant, setDesignVariant] = useState(() => localStorage.getItem('designVariant') || 'A');

  useEffect(() => {
    function onVariantChange() {
      setDesignVariant(localStorage.getItem('designVariant') || 'A');
    }
    window.addEventListener('designVariantChange', onVariantChange);
    return () => window.removeEventListener('designVariantChange', onVariantChange);
  }, []);

  return (
    <WeekNavContext.Provider value={{ selectedWeek, setSelectedWeek }}>
      <Router>
        <div className="App">
          <Navbar designVariant={designVariant} setDesignVariant={setDesignVariant} />
          <Routes>
            <Route path="/"        element={<PublicSchedule />} />
            <Route path="/login"   element={<Login />} />
            <Route path="/teacher" element={designVariant === 'B' ? <TeacherDashboardB /> : <TeacherDashboard />} />
            <Route path="/admin"   element={designVariant === 'B' ? <AdminDashboardB /> : <AdminDashboard />} />
          </Routes>
        </div>
      </Router>
    </WeekNavContext.Provider>
  );
}

export default App;
